import { useCallback, useEffect, useState } from 'react';

const KEY = 'newflix:recent';
const CAP = 12;

function read(): string[] {
  if (typeof window === 'undefined') return [];
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) return JSON.parse(raw) as string[];
  } catch {
    // ignore
  }
  return [];
}

/** 슬러그를 최근 본 목록 맨 앞에 추가 (dedup, CAP 제한). */
export function recordRecentlyViewed(slug: string) {
  if (typeof window === 'undefined') return;
  const next = [slug, ...read().filter((s) => s !== slug)].slice(0, CAP);
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    // ignore
  }
}

/** 최근 본 슬러그 목록. exclude 로 현재 보고 있는 항목 제외. */
export function useRecentlyViewed(exclude?: string): string[] {
  // Empty first paint → matches SSR; load localStorage after mount (hydrate-safe).
  const [slugs, setSlugs] = useState<string[]>([]);
  useEffect(() => {
    setSlugs(read());
  }, []);
  const filter = useCallback((list: string[]) => list.filter((s) => s !== exclude), [exclude]);
  return filter(slugs);
}
